import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import Big from 'big.js';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { ProductFilter } from 'src/app/models/filters/product-filter';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { ProductTableModel } from 'src/app/models/table-models/product-table';
import { Tax } from 'src/app/models/tax';
import { ProductsService } from 'src/app/services/products.service';

@Component({
  selector: 'app-pos-product-list',
  templateUrl: './pos-product-list.component.html',
  styleUrls: ['./pos-product-list.component.sass'],
})
export class PosProductListComponent implements OnInit {
  @Output() selectedProductChange = new EventEmitter<ProductTableModel>();
  products: Paging<Array<ProductTableModel>> = new Paging([]);
  filters = [
    new FilterTable('text', 'Búsqueda General'),
    new FilterTable('hasExistence', 'Existencia', { type: 'switch' }),
  ];

  private taxes: Array<Tax> = [];

  constructor(private productsService: ProductsService) { }

  async ngOnInit(): Promise<void> {
    await this.getProductData({ page: 0, pageSize: 5, value: {} });
  }

  async getProductData(params: Filter<ProductFilter>): Promise<void> {
    let result = (await this.productsService.readProducts(params).toPromise())
      .response;

    this.products = new Paging(
      result.content.map((m) => {
        let model = new ProductTableModel();
        let tax = this.taxes.find((w) => w.code == m.taxCode) || new Tax();
        let price = this.getPriceWithoutTax(m.price.amount, tax);
        return model
          .setCode(m.code)
          .setDescription(m.description)
          .setTotal(m.price.amount)
          .setPrice(price)
          .setStock(m.carStock || 0)
          .setTax(tax.value)
          .setTaxCode(tax.code)
          .setRequiredSerial(m.serialProfile)
          .setFeatures(m.features);
      })
    ).setValues(result);
  }

  async productRowClick(product: ProductTableModel): Promise<void> {
    this.selectedProductChange.emit(product);
  }

  private getPriceWithoutTax(price: number, tax: Tax) {
    return Number.parseFloat(
      Big(price)
        .div(Big(1).plus(Big(tax.value).div(100)))
        .toFixed(2)
    );
  }
}
